module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_proofreading-b7776353534ad36f331b7b30c59dd9b6.svg";